import { useDebugValue } from 'react';

import { generatedKeys } from '@app/data/queryKeysFactory';
import { useMutation, useQuery } from '@app/QueryClient';
import {
	freemiumVouchersExpired,
	freemiumVouchersExpiredExport,
} from '@app/Services/LoyaltyProgramme';
import { TVouchersExpiredReports } from '@modules/LoyaltyProgramme/types';
import { usePagination, useQueryString } from '@zeal/zeal-lib';

const { freemiumLoyalty } = generatedKeys;

export function useVouchersExpired() {
	const [{ from, to, last_from, last_to, page }] = useQueryString();

	const q = useQuery({
		queryFn: freemiumVouchersExpired,
		staleTime: Infinity,
		queryKey: freemiumLoyalty?.vouchersExpired?.({
			from,
			to,
			last_from,
			last_to,
			page,
		}) as string[],
	});

	const pagination = usePagination({
		pageNum: q?.data?.meta.current_page || 1,
		pagesCount: q?.data?.meta.last_page || 1,
	});

	useDebugValue(q);

	return { ...q, data: q.data?.data as TVouchersExpiredReports[], pagination };
}

export function useVouchersExpiredExport(opt?: {
	onSuccess?: () => void;
	onError?: () => void;
}) {
	const [{ from, to }] = useQueryString();

	const mutation = useMutation(
		() => freemiumVouchersExpiredExport({ from, to }),
		{
			...opt,
			moduleName: 'freemiumLoyalty',
			operation: 'add',
			disableToaster: true,
		}
	);

	const { mutate } = mutation;

	return {
		...mutation,
		doVouchersExpiredExport: mutate,
	};
}
